import { render, staticRenderFns } from "./BestSuggestionsWidget.vue?vue&type=template&id=364423ec&scoped=true&"
import script from "./BestSuggestionsWidget.vue?vue&type=script&lang=js&"
export * from "./BestSuggestionsWidget.vue?vue&type=script&lang=js&"
import style0 from "./BestSuggestionsWidget.vue?vue&type=style&index=0&id=364423ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364423ec",
  null
  
)

export default component.exports